export default __webpack_public_path__ + "static/media/home-center.bb4d5ffb.png";